import React from 'react';
import LocationTemplate from './LocationTemplate';

const SpeedPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Speed"
      stateName="North Carolina"
      countyName="Edgecombe"
      zipCodes={["27881"]}
      latitude={35.9679}
      longitude={-77.4322}
      population={80}
      historicalFact="Small town incorporated in 1909, named after the Speed family."
      nearbyTowns={[
        "Rocky Mount, NC",
        "Tarboro, NC",
        "Nashville, NC",
        "Red Oak, NC",
        "Enfield, NC",
        "Whitakers, NC",
        "Battleboro, NC",
        "Halifax, NC"
      ]}
    />
  );
};

export default SpeedPage;